import { get, kebabCase } from 'lodash';

import imagesMappedToUrls from './imagesMappedToUrls';
import richTextNodeToString from '../Contentful/richTextNodeToString';

// Handle learn article, seo node, or page node
export default function articleToJSONLD(node) {
  if (node == null) return null;
  const { content, page, seo } = node;
  if (content == null && page == null && seo == null) return null;

  let authorName;
  let datePublished;
  let dateModified;
  let description;
  let headline;
  let image;
  let url;

  // Set Attributes
  if (seo != null) {
    // SEO Node
    authorName = get(node, 'article.author.name');
    datePublished = get(node, 'article.createdAt');
    dateModified = get(node, 'article.updatedAt');
    description = seo.description;
    headline = seo.title;
    image = imagesMappedToUrls(node.images || []);
    if (image == null || (image || []).length === 0) {
      image = 'https://upsolve.org/images/meta-legalaid.png';
    }
  } else if (page != null) {
    // Page Node
    authorName = get(page, 'author.name');
    datePublished = page.createdAt;
    dateModified = page.updatedAt;
    description = get(page, 'summary.json') || get(page, 'content.json') != null
      ? richTextNodeToString(get(page, 'summary.json') || get(page, 'content.json'), 155)
      : '';
    headline = page.title;
    image = 'https://upsolve.org/images/meta-legalaid.png';
    url = `https://upsolve.org${page.path}`;
  } else if (content != null) {
    // Learn Article Node
    headline = content.title;
    description = get(content, 'articleExcerpt.childMarkdownRemark.articleExcerpt') || get(content, 'articleExcerpt.articleExcerpt');
    image = (get(content, 'image.file.url') || get(content, 'seoImage.image.file.url')
      || get(content, 'coverImage.image.file.url') || '//upsolve.org/images/meta-legalaid.png').replace(/^\/\//, 'https://');
    datePublished = content.publishedAt || content.createdAt;
    dateModified = get(content, 'updatedAt');
    authorName = get(content, 'author.name');
  }
  // Set urls
  if (node.path != null) {
    url = `https://upsolve.org${node.path}`;
  } else if (node.url != null) {
    url = node.url;
  }

  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': url,
    },
    headline,
    description,
    image,
    datePublished: datePublished != null ? new Date(datePublished).toISOString() : new Date().toISOString(),
    dateModified: dateModified != null ? new Date(dateModified).toISOString() : undefined,
    author: authorName != null
      ? {
        '@context': 'http://schema.org',
        '@type': 'Person',
        name: authorName,
        url: `https://upsolve.org/authors/${kebabCase(authorName).toLowerCase()}/`,
      }
      : { '@type': 'Organization', name: 'Upsolve' },
    publisher: {
      '@type': 'Organization',
      name: 'Upsolve',
      logo: {
        '@type': 'ImageObject',
        height: 60,
        url: 'http://static.upsolve.org/logos/upsolve-icon-60.png',
        width: 60
      },
    },
  };
}
